<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li>
            <a href="javascript:;" @click="$router.push({name: 'technology'})">{{ $t('technology')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'science'})">{{ $t('science')}}</a>
          </li>
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'patent'})">{{ $t('patent')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="page-swiper">
      <div class="w1200">
        <div class="swiper-containera">
          <div class="swiper-wrapper">
            <div class="swiper-slide bounceInUp wow" v-for="(data ,index) in datas" :key="index" data-wow-duration="1s" :data-wow-delay="0.3*index + 's'">
              <div>
                <img :src="data.image" alt="">
              </div>
              <span>{{data.title}}</span>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-paginationa"></div>
        </div>
      </div>
      <div class="swiper-button-preva"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-button-nexta"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Fetch from '../js/ajax'
export default {
  name: 'Science',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      datas: []
    }
  },
  mounted () {
  },
  methods: {
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 3
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    let postid
    if (localStorage.getItem('lang') === 'cn' || localStorage.getItem('lang') === null) {
      postid = 2
    } else {
      postid = 4
    }
    Fetch.post('Api/certificate', {
      classify_id: postid
    }).then((res) => {
      that.datas = res.result
      setTimeout(function () {
        var myswipera = new Swiper('.swiper-containera', {// eslint-disable-line no-unused-vars
          loop: false,
          slidesPerView: 4,
          navigation: {
            nextEl: '.swiper-button-nexta',
            prevEl: '.swiper-button-preva'
          },
          pagination: {
            el: '.swiper-paginationa',
            clickable: true
          }
        })
      }, 200)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner3{
    background: url(../assets/pagebanner3.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-swiper{
    height: 608px;
    position: relative;
  }
  .swiper-containera{
    height: 425px;
    margin-top: 80px;
  }
  .swiper-containera .swiper-slide{
    width: 300px;
    height: 425px;
    box-sizing: border-box;
    padding: 0 10px;
  }
  .swiper-containera .swiper-slide div{
    width: 100%;
    height: 380px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-containera .swiper-slide div img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
  .swiper-containera .swiper-slide span{
    display: block;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    color: #333;
  }
  .swiper-containera .swiper-slide:hover div{
    background-color: #f3f3f3;
  }
  .swiper-containera .swiper-slide:hover span{
    color: #E40A1F;
  }
  .swiper-button-nexta{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    margin-left: 653px;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    transform: rotate(180deg);
    transform-origin: 50% 50%;
    z-index: 20;
  }
  .swiper-button-preva{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    margin-left: -673px;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    z-index: 20;
  }
  .swiper-button-nexta:hover,.swiper-button-preva:hover{
    background:url(../assets/jiantouh.png) 0 0 no-repeat;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    min-width: 168px;
    height: 60px;
  }
  .pagenav li a{
    display: block;
    width: auto;
    height: 100%;
    padding: 0 5px;
    line-height: 60px;
    text-align: center;
    color: #999999;
    margin: 0 5px;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/patent.vue